
import { SeatLayoutComponent } from './components/seat-layout/seat-layout.component';
import { NavtabComponent } from './components/navtab/navtab.component';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule, ModuleWithProviders } from '@angular/core';
import {
  TranslateModule, TranslateLoader, TranslateService, MissingTranslationHandler
} from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { SidebarModule } from 'primeng/sidebar';

import { TripMapComponent } from './components/trip-map/trip-map.component';
import { TripDetailsComponent } from './components/trip-details/trip-details.component';
import { BookingHistoryTripDetailsComponent } from './components/booking-history-trip-details/booking-history-trip-details.component';
import { BookingUserDetailsComponent } from './components/booking-user-details/booking-user-details.component';
import { BookingDriverDetailsComponent } from './components/driver-details/booking-driver-details.component';
import { BookingCancellationComponent } from './components/booking-cancellation/booking-cancellation.component';

import { MenuModule } from 'primeng/components/menu/menu';
import { ChartModule } from 'primeng/components/chart/chart';
import { GrowlModule } from 'primeng/components/growl/growl';
import { ButtonModule } from 'primeng/components/button/button';
import { DialogModule } from 'primeng/components/dialog/dialog';
import { EditorModule } from 'primeng/components/editor/editor';
import { RatingModule } from 'primeng/components/rating/rating';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BlockUIModule } from 'primeng/components/blockui/blockui';
import { TabMenuModule } from 'primeng/components/tabmenu/tabmenu';
import { TabViewModule } from 'primeng/components/tabview/tabview';
import { ConfirmationService } from 'primeng/components/common/api';
import { CalendarModule } from 'primeng/components/calendar/calendar';
import { CheckboxModule } from 'primeng/components/checkbox/checkbox';
import { DropdownModule } from 'primeng/components/dropdown/dropdown';
import { PanelMenuModule } from 'primeng/components/panelmenu/panelmenu';
import { FileUploadModule } from 'primeng/components/fileupload/fileupload';
import { RadioButtonModule } from 'primeng/components/radiobutton/radiobutton';
import { AutoCompleteModule } from 'primeng/components/autocomplete/autocomplete';
import { OverlayPanelModule } from 'primeng/components/overlaypanel/overlaypanel';
import { ConfirmDialogModule } from 'primeng/components/confirmdialog/confirmdialog';


import { UiService } from './services/ui.service';
import { RestApiService } from './services/rest-api.service';
import { UserCommonService } from './services/user-common.service';
import { StorageService } from './services/storage.service';
import { ErrorBindingService } from './services/error-binding.service';
import { CommonBindingDataService } from './services/common-binding-data.service';
import { SidebarService } from './services/sidebar.service';
import { AuthenticationValidationService } from './services/authentication-validation.service';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { MiTranslateLoaderService } from './services/mi-translate-loader.service';
import { MiMissingTranslationHandlerService } from './services/mi-missing-translation-handler.service';
import { MiGridComponent } from './mi-grid/mi-grid.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { AssignSearchComponent } from './components/assign-search/assign-search.component';
import { PieChartComponent } from './components/pie-chart/pie-chart.component';
import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { DashboardStatsCountsComponent } from './components/dashboard-stats-counts/dashboard-stats-counts.component';
import { DashboardActivityComponent } from './components/dashboard-activity/dashboard-activity.component';
import { LoaderService } from './components/loader/loader.service';
import { LoaderComponent } from './components/loader/loader.component';
import { FileUploaderComponent } from './components/file-uploader/file.uploader.component';
import { AgoPipe } from './pipes/ago.pipe';
import { DateFormatPipe } from './pipes/dateformat.pipe';
import { DateTimeFormatPipe } from './pipes/datetimeformat.pipe';
import { MinutsFormatPipe } from './pipes/minutesformat.pipe';
import { TotalAndActiveCountsComponent } from './components/total-and-active-counts/total-and-active-counts.component';
import { NotificationMG1Component } from './components/notification-mg1/notification-mg1.component';
import { CommentInfoComponent } from './components/comment-info/comment-info.component';
import { CommentReplyComponent } from './components/comment-reply/comment-reply.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { AutocompleteSearchComponent } from './components/autocomplete-search/autocomplete-search.component';
import { SearchLocationDirective } from './directives/search-location.directive';
import { DisableControlDirective } from './directives/input-disabled.directive';

import { BusLayoutComponent } from './components/bus-layout/bus-layout.component';
import { OtpVerifiyComponent } from './components/otp-verifiy/otp-verifiy.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { RecentEmergencyRequestComponent } from './components/recent-emergency-request/recent-emergency-request.component';
import { OtpComponent } from './components/otp/otp.component';
import { TrackLocationComponent } from './components/track-location/track-location.component';
import { MiGridV2Component } from './mi-grid-v2/mi-grid-v2.component';
import { KeepHtmlPipe } from './pipes/keep-html.pipe';
import { A11yModule } from '@angular/cdk/a11y';
import { ConfirmDialogFocusDirective } from './directives/confirm-dialog-focus.directive';
import { NoWhiteSpaceDirective } from './directives/no-white-space.directive';
import { Safe } from './pipes/safe.pipe';
import { ProgressSpinnerModule, MenubarModule } from 'primeng/primeng';
import { AccessProviderDirective } from './directives/access-provider.directive';
import { EditMiGridComponent } from '../bus-manage-tour/pages/edit-mi-grid/edit-mi-grid.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { UploadFileAccessibilityDirective } from './directives/upload-file-accessibility.directive';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TableModule,
    SidebarModule,
    PanelMenuModule,
    RatingModule,
    ButtonModule,
    EditorModule,
    ConfirmDialogModule,
    CalendarModule,
    GrowlModule,
    ChartModule,
    MenuModule,
    DropdownModule,
    RadioButtonModule,
    CheckboxModule,
    DialogModule,
    FormsModule,
    FileUploadModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    BlockUIModule,
    OverlayPanelModule,
    TabMenuModule,
    TabViewModule,
    A11yModule,
    MenubarModule,
    ProgressSpinnerModule,
    InfiniteScrollModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: MiTranslateLoaderService
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MiMissingTranslationHandlerService
      }
    }),
    // AgGridModule.withComponents([])
  ],
  declarations: [
    HeaderComponent,
    SidebarComponent,
    PageHeaderComponent,
    MiGridComponent,
    EditMiGridComponent,
    DisableControlDirective,
    SearchLocationDirective,
    ChangePasswordComponent,
    EditProfileComponent,
    AssignSearchComponent,
    PieChartComponent,
    BarChartComponent,
    DashboardStatsCountsComponent,
    DashboardActivityComponent,
    LoaderComponent,
    FileUploaderComponent,
    AgoPipe,
    Safe,
    DateFormatPipe,
    DateTimeFormatPipe,
    MinutsFormatPipe,
    TotalAndActiveCountsComponent,
    BookingDriverDetailsComponent,
    BookingUserDetailsComponent,
    TripDetailsComponent,
    TripMapComponent,
    NotificationMG1Component,
    CommentInfoComponent,
    CommentReplyComponent,
    ForgotPasswordComponent,
    OtpVerifiyComponent,
    BookingHistoryTripDetailsComponent,
    AutocompleteSearchComponent,
    SeatLayoutComponent,
    BusLayoutComponent,
    // OtpVerifiyComponent,
    SetPasswordComponent,
    NavtabComponent,
    BookingCancellationComponent,
    RecentEmergencyRequestComponent,
    OtpComponent,
    TrackLocationComponent,
    MiGridV2Component,
    KeepHtmlPipe,
    ConfirmDialogFocusDirective,
    UploadFileAccessibilityDirective,
    NoWhiteSpaceDirective,
    AccessProviderDirective
  ],
  exports: [
    MiGridV2Component,
    HeaderComponent,
    SidebarComponent,
    PageHeaderComponent,
    TranslateModule,
    ConfirmDialogModule,
    MiGridComponent,
    EditMiGridComponent,
    SearchLocationDirective,
    DisableControlDirective,
    ConfirmDialogFocusDirective,
    UploadFileAccessibilityDirective,
    AssignSearchComponent,
    PieChartComponent,
    BarChartComponent,
    DashboardStatsCountsComponent,
    DashboardActivityComponent,
    LoaderComponent,
    FileUploaderComponent,
    AgoPipe,
    Safe,
    DateFormatPipe,
    DateTimeFormatPipe,
    MinutsFormatPipe,
    TotalAndActiveCountsComponent,
    BookingDriverDetailsComponent,
    BookingUserDetailsComponent,
    TripDetailsComponent,
    TripMapComponent,
    NotificationMG1Component,
    CommentInfoComponent,
    ForgotPasswordComponent,
    OtpVerifiyComponent,
    BookingHistoryTripDetailsComponent,
    AutocompleteSearchComponent,
    SeatLayoutComponent,
    BusLayoutComponent,
    SetPasswordComponent,
    NavtabComponent,
    BookingCancellationComponent,
    RecentEmergencyRequestComponent,
    OtpComponent,
    TrackLocationComponent,
    NoWhiteSpaceDirective,
    AccessProviderDirective
  ]
})
export class SharedModule {

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        DatePipe,
        LoaderService,
        DatePipe,
        RestApiService,
        UiService,
        UserCommonService,
        StorageService,
        ErrorBindingService,
        CommonBindingDataService,
        SearchLocationDirective,
        DisableControlDirective,
        ConfirmDialogFocusDirective,
        UploadFileAccessibilityDirective,
        AuthenticationValidationService,
        ConfirmationService,
        TranslateService,
        SidebarService,
        NoWhiteSpaceDirective,
        AccessProviderDirective,
        DatePipe
      ]
    };
  }

  constructor(translate: TranslateService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('en');

  }

}
